@import "~/styles/variables";

.ModalScrollable {
  flex: 1;
  height: 100%;
  overflow-y: auto;

  &.center {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
}
